<template>
  <form @submit.prevent="authenticateOnlineID" autocomplete="off">
    <v-row no-gutters  justify="center">
      <v-col cols="12" sm="9">
        <v-text-field name="orderNr"
                      :label="$t('debtNr')"
                      id="orderNr"
                      typeof="number"
                      v-model="orderNr"
                      @blur="$v.orderNr.$touch()"
                      @input="$v.orderNr.$touch()"
                      :error-messages="orderNrError"></v-text-field>
      </v-col>
      <v-col cols="12" sm="9">
        <v-text-field name="onlineId"
                      typeof="number"
                      :label="$t('onlineId')"
                      id="onlineId"
                      v-model="onlineId"
                      @blur="$v.onlineId.$touch()"
                      @input="$v.onlineId.$touch()"
                      :error-messages="onlineIdError"></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-btn tile block color="primary" type="submit" :disabled="!formIsValid || loading" :loading="loading">
          {{ $t('loginButton') }}
        </v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
  import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

  export default {
    data: function () {
      return {
        orderNr: '',
        onlineId: ''
      }
    },
    computed: {
      formIsValid () {
        return !this.$v.orderNr.$error && !this.$v.onlineId.$error
      },
      orderNrError () {
        const errors = []
        if (!this.$v.orderNr.$dirty) return errors
        !this.$v.orderNr.required && errors.push(this.$t('orderNrErrors.required'))
        !this.$v.orderNr.numeric && errors.push(this.$t('orderNrErrors.numeric'))
        !this.$v.orderNr.minLength && errors.push(this.$t('orderNrErrors.length'))
        !this.$v.orderNr.maxLength && errors.push(this.$t('orderNrErrors.length'))
        return errors
      },
      onlineIdError () {
        const errors = []
        if (!this.$v.onlineId.$dirty) return errors
        !this.$v.onlineId.required && errors.push(this.$t('onlineIdErrors.required'))
        !this.$v.onlineId.numeric && errors.push(this.$t('onlineIdErrors.numeric'))
        !this.$v.onlineId.minLength && errors.push(this.$t('onlineIdErrors.length'))
        !this.$v.onlineId.maxLength && errors.push(this.$t('onlineIdErrors.length'))
        return errors
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    methods: {
      authenticateOnlineID () {
        var credentials = {
          LoginType: 2,
          Username: this.orderNr,
          Password: this.onlineId
        }
        this.$store.dispatch('authenticateUser', credentials)
      }
    },
    validations: {
      orderNr: {
        required,
        numeric,
        minLength: minLength(1),
        maxLength: maxLength(8)
      },
      onlineId: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(8)
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "orderNrErrors": {
  "required": "Asianumero on pakollinen.",
  "numeric": "Asianumeron tulee olla numero",
  "length": "Asianumeron tulee olla 1-8 numeroa pitkä"
  },
  "onlineIdErrors": {
  "required": "Oma B2 Impact tunnus on pakollinen.",
  "numeric": "Oma B2 Impact tunnuksen tulee olla numero",
  "length": "Oma B2 Impact tunnus tulee olla kahdeksannumeroinen"
  }
  },
  "se": {
  "orderNrErrors": {
  "required": "Ärendenumret är obligatoriskt",
  "numeric": "Ärendenumret bör vara numeriskt",
  "length": "Ärendenumret bör vara mellan 1-8 tecken"
  },
  "onlineIdErrors": {
  "required": "Min B2 Impact ID är obligatoriskt",
  "numeric": "Min B2 Impact ID bör vara numeriskt",
  "length": "Min B2 Impact ID bör vara åttasiffrigt"
  }
  },
  "en": {
  "orderNrErrors": {
  "required": "The case number is mandatory",
  "numeric": "The case number must be numeric",
  "length": "The case number must be between 1-8 numbers long"
  },
  "onlineIdErrors": {
  "required": "My B2 Impact ID is mandatory",
  "numeric": "My B2 Impact ID must be numeric",
  "length": "My B2 Impact ID must be eight digits"
  }
  }
  }
</i18n>
